import '../compat/polyfills'
import { createApp } from 'vue/dist/vue.esm-bundler'
import { createBootstrap } from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import Popover from 'bootstrap/js/dist/popover'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/collapse'
import mitt from 'mitt'

import '../../stylesheets/application.scss'
import { installFontAwesome } from './fontawesome'

const defaultDomainDesign = Object.freeze({
  profile: 'medevrika_v1',
  domainKey: 'medevrika_medical',
  brand: {
    product_name: 'Медэврика',
    assistant_name: 'Медэврика GPT'
  },
  assets: {
    assistant_mark: 'logo-noletter.svg'
  }
})

export const readDomainDesignContext = () => {
  const element = document.getElementById('domain-design-context')
  if (!element?.textContent) {
    return defaultDomainDesign
  }

  try {
    return Object.freeze(JSON.parse(element.textContent))
  } catch (error) {
    console.error('Unable to parse domain design context', error)
    return defaultDomainDesign
  }
}

const inlineHtmlDirective = (el) => {
  if (!el) {
    return
  }

  const content = el.tagName === 'TEMPLATE' ? el.content : el
  if (content.children.length === 1) {
    [...el.attributes].forEach((attr) => content.firstChild.setAttribute(attr.name, attr.value))
  }

  if (el.tagName === 'TEMPLATE') {
    el.replaceWith(el.content)
  } else {
    el.replaceWith(...el.children)
  }
}

const initPopovers = () => {
  document
    .querySelectorAll('[data-bs-toggle="popover"]')
    .forEach((el) => new Popover(el))
}

export const mountFrontend = ({ components = {}, plugins = [], enablePopovers = true } = {}) => {
  const mount = () => {
    const app = createApp()
    const eventBus = mitt()
    const domainDesign = readDomainDesignContext()

    app.config.globalProperties.eventBus = eventBus
    app.config.globalProperties.$domainDesign = domainDesign
    app.provide('domainDesign', domainDesign)

    app.use(createBootstrap())
    installFontAwesome(app)
    plugins.forEach((plugin) => app.use(plugin))

    Object.entries(components).forEach(([name, component]) => {
      app.component(name, component)
    })

    app.directive('inline-html', inlineHtmlDirective)
    app.mount('body')

    if (enablePopovers) {
      initPopovers()
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true })
  } else {
    mount()
  }
}
